module.exports = __webpack_public_path__ + "static/media/poems.24fd776f.jpg";